<template>
  <div>
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      角色<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="page_edit_table">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">角色基本信息</td>
        </tr>
        <!--div class="error_msg">{{ errors.first('form.value') }}</div-->
        <tr>
          <td align="center"  class="t_left3">角色名称：</td>
          <td><input name="" type="text" class="put_txt w200" v-model="form.name" /><span>*</span></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">英文名称：</td>
          <td><input name="" type="text" class="put_txt w200" v-model="form.nameEn" /><span>*</span></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">角色类型：</td>
          <td><select v-model="form.type">
            <option value="4">教师</option>
            <option value="3">游客</option>
            <option value="2">机构管理员</option>
            <option value="1">超级管理员</option>
          </select></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">是否系统数据：</td>
          <td><select v-model="form.isSystem"><option value="1">是</option><option value="2">否</option></select><i>"是"代表此数据只有超级管理员能进行修改，"否"则表示拥有角色修改人员的权限都能进行修改</i></td>
        </tr>
        <!--tr>
          <td align="center"  class="t_left3">是否可用：</td>
          <td><select name=""><option>是</option><option>否</option></select><i>"是"代表此数据可用，"否"则表示此数据不可用</i></td>
        </tr-->
        <tr>
          <td align="center"  class="t_left3">角色授权：</td>
          <td>
            <div style="height: 250px; overflow: scroll;">
              <TreeSelect :data="menus"></TreeSelect>
            </div>
          </td>
        </tr>
        <tr>
          <td class="t_left2">&nbsp;</td>
          <td align="left"  class="t_left2">
            <input name="" type="button" class="put_btn" value="确认提交" @click="validateForm('form')" />　
            <!--input name="" class="put_btn" type="button" value="重填" /-->
          </td>
        </tr>
      </table>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Bus from '@/utils/bus'
  import TreeSelect from '@/page/byl/sys/role/treemenu2.vue'
  export default {
    components: { TreeSelect },
    data () {
      return {
        form: {
          type: '2',
          isSystem: '1'
        },
        filters: {
          isShow: '',
          roleList: []
        },
        menus: [],
        selected: [],
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      if (!this.isEdit) {
        this.getMenus(this.filters)
      }
    },
    mounted () {
      var that = this
      this.$on('menu-prepared', function (data) {
        this.menus = data
      });
      if (this.isEdit) { // 通过 id 取信息并且要给select赋值
        this.getModel(this.$route.params.id)
        this.$on('data-prepared', function (data) {
          var menuList = data.menuList
          that.form.menuList = data.menuList
          this.getMenus(this.filters) // 确保取到数据以后再去取Menus
          this.$on('menu-prepared', function (data) {
            this.menus = data
            if (menuList && menuList.length > 0) {
              for (let i = 0; i < menuList.length; i++) {
                var menu = menuList[i]
                for (let j = 0; j < this.menus.length; j++) {
                  var m = this.menus[j]
                  if (m.id == menu.menuId) {
                    if (m.checked == false) {
                      m.checked = true
                    }
                    if (!m.checked) { // !!!
                      that.$set(m, 'checked', true)
                    }
                  }
                  var _setC = function (o) {
                    if (o) {
                      for (let j = 0; j < o.length; j++) {
                        if (o[j].id == menu.menuId) {
                          if (o[j].checked == false) {
                            o[j].checked = true
                          }
                          if (!o[j].checked) {
                            that.$set(o[j], 'checked', true)
                          }
                        }
                        _setC(o[j].children)
                      }
                    }
                  }
                  _setC(m.children)
                }
              }
            }
          });
        });
      }
      Bus.$on('selected-menu', function (data) { // 选中的菜单项目
        that.selected = data
      })
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    methods: {
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          if (bus.selected.length > 0) { // 如果有新选择的情况
            var r = []
            for (let i = 0; i < bus.selected.length; i++) {
              let o = {}
              let menu = bus.selected[i]
              o.menuId = menu.id
              o.menuName = menu.name
              r.push(o)
            }
            bus.form.menuList = r
          }
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _dealParams()
            bus.confirmBox({
              yes: function () {
                api.post(config.bylBaseCenterPath, '/role/edit', bus.form, function (r) { // 正常
                  if (bus.isEdit) { // 编辑
                    bus.popup('保存成功')
                  } else {
                    bus.popup('创建角色成功')
                  }
                  bus.$router.push(bus.prefix + '/org/roleList')
                })
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (id) {
        var that = this
        api.get(config.bylBaseCenterPath, '/role/'  + id, null, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      },
      getMenus (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.bylBaseCenterPath, '/menu/list', filters, function (r) { // 正常
          that.$emit('menu-prepared', r.data)
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/orgrole/model.vue